module.exports = __webpack_public_path__ + "media/images/photos/man-holding-tablet-2df6bf803f577b3dd402d20fa97003ea.jpg";